import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import BackBtn from "../../../UI/BackBtn";
import Page from "../../../_layout/Page";
import {useStore} from "../../../../stores/StoreHelpers";
import {useHistory, useParams} from "react-router-dom";
import style from "./TabResults.module.less";
import {observer} from "mobx-react";
import {status as Strategy_Status} from "../../../../helpers/StrategyProject/stratProjectHelpers";

import {ResultCardForm} from "./ResultCardForm";
import useAPI from "../../../../hooks/useAPI";
import useToast from "../../../../hooks/useToast";
import {StrategyRequests} from "../../../../requests/StrategyRequests/strategyRequests";
import useUserContext from "../../../../hooks/useUserContext";
import HintCard from "../../../common/HintCard/HintCard";
import {useRequestObject} from "../../../../hooks/useRequestObject";
import {isAdmin} from "../../../../services/rolesSvc";

const StratResultsEditView = observer(() => {
    const store = useStore()
    const api = useAPI()
    const addToast = useToast();
    const history = useHistory()
    const [validated,setValidated] = useState(false)
    const formEl = useRef(null);
    let {stratId,resultId,mileStoneId} = useParams();

    const refScroll = useRef(null)
    const userCtx = useUserContext();

    let currentResultNum = null
    const requestObject = useRequestObject({classType:StrategyRequests, stratId, api, addToast, store})
    const currentResult = store.strategies.planResults.filter(x=>x?.id===Number(resultId))

    const [projects, setProjects] = useState([])
    const [strategy, setStrategy] = useState({})

    useEffect(()=>{
        const getStrategy = async() => api.get(`/mng/strategies/${stratId}`)
        const getProjects = async() => api.get(`/projs?short=true&strategyId=${stratId}`)
        getStrategy()
            .then(strategy => setStrategy(strategy))
        getProjects()
            .then(projects => setProjects(projects.map((project) => ({...project, id: project.originId})).sort((a, b) => a.fullNumber.length - b.fullNumber.length || +a.fullNumber - +b.fullNumber)))
            .catch(() => addToast.error('Не удалось загрузить данные'))
        if(store.strategies.planResults.length === 0) {
            const fetchResult = async () => {
                return await api.get(`/strategies/${stratId}/results?full=true`)
            }
            fetchResult()
                .then(x => {
                    store.strategies.setPlanResults(x.map(res => {
                    if(res.milestones){
                        res.milestones = res.milestones.map(milestone => ({...milestone, projs: milestone.projs ? milestone.projs.map(proj => ({...proj, id: proj.originId})) : []}))
                    }
                    return {...res, projs: res.projs ? res.projs.map(proj => ({...proj, id: proj.originId})) : []}
                    }))
                    if(store.strategies.planResults.length === 0) {
                        store.strategies.addPlanResults(stratId)
                    }
                })
                .catch(() => addToast.error('Не удалось загрузить данные.'))
        }
        if (store.strategies.trls.length === 0) {
            requestObject.handleAddResult().catch()
        }
    },[])

    const headerResult = (
        <div ref={refScroll}>
            <HintCard text={"Укажите информацию о выдающихся достижениях стратегического проекта (например, о разработанных технологиях, УГТ, зарегистрированных патентах, и т.д.)"}/>
        </div>
    )
    const scrollToStart = () => {
        window.scrollTo(0, refScroll.current.scrollHeight)
    }

    const isResultContainsReturnedOrPendingStatus = () => {
        const currMilestone = (currentResult[0]?.milestones || []).filter(x=>x.id===+mileStoneId)[0]
        if(!+mileStoneId  && (currentResult[0]?.status === Strategy_Status.returned || currentResult[0]?.status === Strategy_Status.inProgress)){
            return true
        }
        else if (!!+mileStoneId && (currMilestone?.status === Strategy_Status.returned || currMilestone?.status === Strategy_Status.inProgress)){
            return true
        }
        else return false
    }

    const saveButton = (<Row className={style.stickyButtons}>
        <Col>
            <Card>
                <Card.Body >
                    {(!!isAdmin(userCtx) || !!isResultContainsReturnedOrPendingStatus()) ? <Button type="submit"  variant={'outline-primary'}>Сохранить</Button> : <></>}
                    {!!isResultContainsReturnedOrPendingStatus() ? <Button
                        type="button"
                        style={{marginLeft:'20px'}}  variant={'outline-warning'}
                        onClick={(event)=>requestObject.handleSubmitForm(null,formEl,()=>requestObject.saveFactResults(Number(resultId),+mileStoneId).then(()=>requestObject.sendToProjOffice(!Number(mileStoneId)?Number(resultId):Number(mileStoneId))).then(scrollToStart),(flag)=>setValidated(flag),true,resultId,mileStoneId)}>
                        Отправить в проектный офис
                    </Button> : <></>}
                    <Button type={"button"}
                            style={{color:'#0D6EFD', marginLeft: 20}}
                            onClick = {()=>{
                                store.strategies.clearNoSavedPlanResults();
                                 history.push(`/strats/${stratId}/?t=results`)
                            }}
                            variant='light'>Перейти в реестр</Button>
                </Card.Body>
            </Card>
        </Col>
    </Row>)

    return (
        <Page  styleSection={{backgroundColor:'#F5F5FF'}}className="projects-page">
            <Row>
                <Col sm={'2'}>
                    <BackBtn onClick = {()=>{
                        history.goBack()
                    }}/>
                </Col>
            </Row>
            {strategy.id && <Row>
                <Col className={style.headerProject}>
                    {`Выдающиеся результаты ${strategy.num} `}
                </Col>
            </Row>}
            {headerResult}
            <Form noValidate validated={validated} onSubmit={(event)=>requestObject.handleSubmitForm(event,formEl,()=>requestObject.saveFactResults(Number(resultId),+mileStoneId).then(scrollToStart),(flag)=>setValidated(flag), true,resultId,mileStoneId)} ref={formEl}>
                {store.strategies.planResults && store.strategies.planResults.filter((x,y)=> {
                        if (x?.id === Number(resultId)) {
                            currentResultNum = y
                            return true
                        }
                        return false
                    }
                ).map((x,y) => <ResultCardForm
                    key={x?.id || x?.key}
                    index= {currentResultNum ?? x?.num-1}
                    edit={true}
                    value = {x}
                    options={{ygt:store.strategies.trls,getOptions:requestObject.getOptions,stratId,resultId:+resultId,mileStoneId:+mileStoneId}}
                    onChange={(...e) => requestObject.updatePlanResults(e)}
                    userCtx={userCtx}
                    onDelete = {()=>requestObject.deletePlan(x)}
                    onDeleteFile={(fileId,planId)=>requestObject.deleteFile(fileId,planId)}
                    projects={projects}
                />)

                }
                {saveButton}
            </Form>
        </Page>
    );
});

export default StratResultsEditView;

